export const BOARD_URL = "board.flowcloud.me";

export const YCLIENTS_URL = "yclients.com";
export const ALTEGIO_URL = "alteg.io";

export const BILLZ_URL = "billz.ai";
